module.exports = __webpack_public_path__ + "static/img/Gallery08.0416418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery08.jpg
// module id = GlRg
// module chunks = 12